// hooks/useDecryptedInfoToken.ts
import { useEffect } from "react";
import { useCombinedStore } from "../store";
import { decodeToken } from "../services/jwt-decode.service"; // Use a função regular

export const useDecryptedInfoToken = () => {
  const { organizationZustand, decryptedInfoToken, setDecryptedInfoToken } =
    useCombinedStore();

  useEffect(() => {
    // Sem `&& !decryptedInfoToken`, de propósito.
    //
    // Com a guarda, o token só era decodificado UMA vez por sessão: quem salvava
    // uma configuração (que devolve um `InfoToken` novo e o grava no store) saía
    // da aba, voltava, e via o valor ANTIGO até dar reload — porque
    // `decryptedInfoToken` já estava preenchido e o efeito não rodava de novo.
    //
    // Decodificar sempre que o token MUDA é barato (é um decode de JWT, sem
    // rede) e é o que faz a tela contar a verdade depois de salvar. O efeito só
    // dispara quando `InfoToken` muda de fato, então não há laço.
    if (organizationZustand?.InfoToken) {
      // USE decodeToken (função regular) em vez de useDecodedToken (hook)
      const decoded = decodeToken(organizationZustand.InfoToken);
      if (decoded && setDecryptedInfoToken) {
        setDecryptedInfoToken(decoded);
      }
    }
  }, [organizationZustand?.InfoToken, setDecryptedInfoToken]);

  return decryptedInfoToken;
};
